<template>
  <div v-if="loaded">
    <FormKit type="form" class="mt-4" v-model="taskAttrs" :actions="false">
      <FormKit type="text" name="name" label="Task Name" />
      <QuillInput
        :modelValue="taskAttrs.description"
        @update:modelValue="value => (taskAttrs.description = value)"
        name="task-description"
        label="Task Description"
      />
      <FormKit
        type="select"
        label="Assigned to"
        name="assigned_to_role"
        :options="{ agent: 'Agent', other: 'Other' }"
        placeholder="Select a person"
      />
      <FormKit
        v-if="taskAttrs.assigned_to_role === 'other'"
        type="select"
        label="Assigned to"
        name="assigned_to_user_id"
        :options="assignableUsers"
        placeholder="Select a person"
      />
      <FormKit
        type="select"
        label="E-Signature Template"
        :options="templateOptions"
        name="template_id"
        placeholder="Choose a template"
      />
    </FormKit>
  </div>
</template>

<script>
import Card from '../Card/index.vue';
import QuillInput from '../shared/QuillInput.vue';

export default {
  props: {
    task: {
      required: true,
      type: Object,
    },
    assignableUsers: {
      required: true,
      type: Array,
    },
  },
  components: {
    Card,
    QuillInput,
  },
  data() {
    return {
      templates: [],
      taskAttrs: {
        name: '',
        description: '',
        template_id: '',
        assigned_to_role: '',
        assigned_to_user_id: '',
      },
      loaded: false,
    };
  },
  async mounted() {
    await this.fetchEsignatureTemplates();

    this.taskAttrs = {
      ...this.taskAttrs,
      ...this.task,
      template_id: this.task.checklist_taskable.settings?.template_id,
    };
    this.loaded = true;
  },
  methods: {
    async updateTask() {
      const res = await fetch(`/api/task_checklists/${this.task.task_checklist_id}/checklist_tasks/${this.task.id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
        body: JSON.stringify({
          checklist_task: {
            name: this.taskAttrs.name,
            description: this.taskAttrs.description,
            assigned_to_role: this.taskAttrs.assigned_to_role,
            assigned_to_user_id: this.taskAttrs.assigned_to_user_id,
            order: this.taskAttrs.order,
            checklist_taskable: {
              template_id: this.taskAttrs.template_id,
            },
          },
        }),
      });

      const { status } = await res.json();

      if (status === 'success') {
        const checklistType = this.task.task_checklist.checklist_type;
        await this.$router.push(`/settings/company/${checklistType}_checklists/${this.task.task_checklist_id}/edit`);
        this.$store.commit('general/showAlert', {
          alertType: 'success',
          alertTitle: 'Task Updated',
          alertDescription: 'Your task was successfully updated.  Use the button below to dismiss this alert.',
        });
      }
    },
    async fetchEsignatureTemplates() {
      const res = await fetch(`/api/esignature_templates`);
      const { records } = await res.json();

      this.templates = records;
    },
  },
  computed: {
    templateOptions() {
      return this.templates.map(temp => ({
        value: temp.id,
        label: temp.name,
      }));
    },
  },
};
</script>
